const config = {
  apiBaseUrl: process.env.VUE_APP_OSIGU_API_BASE_URL || 'http://api.dev.osigu.sd:8080',
  getTokenMaxAttempts: process.env.VUE_APP_GET_TOKEN_MAX_ATTEMPTS || 5,
  getTokenAttemptDelayInSeconds: process.env.VUE_APP_GET_TOKEN_ATTEMPTS_DELAY_IN_SECONDS || 1,
  clientId: process.env.VUE_APP_CLIENT_ID || 'providers-web',
  clientSecret: process.env.VUE_APP_CLIENT_SECRET || '4612b5e6-98ab-49f4-b62e-31de54128261',
  intercomId: process.env.VUE_APP_INTERCOM_APP_ID || 'mvgu8g25',
  intercomKey: process.env.VUE_APP_INTERCOM_KEY || 'q0qFcEGh1_eWsiG0J3sGHp3Evwt_R7DUAQwfaiuC',
  theme: process.env.VUE_APP_THEME || 'OSIGU',
  locale: process.env.VUE_APP_DEFAULT_LOCALE || 'es',
  preAuthorizationWidgetUrl: process.env.VUE_APP_PREAUTHORIZATION_WIDGET_URL || 'https://preauthorization.widgets.osigu.com/development/160fe26/widget.js',
  biometricValidation: process.env.VUE_APP_BIOMETRIC_VALIDATION || 'true',
  fileSize: process.env.VUE_APP_FILE_SIZE || '20971520',
  maxFileAttachment: process.env.VUE_APP_MAX_FILE_ATTACHMENT || 10,
  showSettlementSection: process.env.VUE_APP_SHOW_SETTLEMENT_SECTION || 'true',
  showAddNewAuthorizationOption: process.env.VUE_APP_SHOW_ADD_NEW_AUTHORIZATION || 'false',
  showOsiguClaimIds: process.env.VUE_APP_SHOW_OSIGU_CLAIM_ID || 'true',
  showRipsView: process.env.VUE_APP_SHOW_RIPS_VIEW || 'false',
  showProductsConfigurationView: process.env.VUE_APP_SHOW_PRODUCTS_CONFIGURATION_VIEW || 'false',
  fingerprintBaseUrl: process.env.VUE_APP_FINGERPRINT_BASE_URL || 'http://localhost:5010',
  fingerprintBodyConfigurationQuality: process.env.VUE_APP_FINGERPRINT_BODY_CONFIGURATION_QUALITY || 80,
  fingerprintBodyConfigurationTimeout: process.env.VUE_APP_FINGERPRINT_BODY_CONFIGURATION_TIMEOUT_IN_MS || 1000,
  requestFingerprintTimeoutInSeconds: process.env.VUE_APP_FINGERPRINT_REQUEST_TIMEOUT_IN_SECONDS || 15,
  validSponsorManualAuthorization: process.env.VUE_APP_VALID_SPONSOR_MANUAL_AUTHORIZATION || 'do-universal',
  isRequiredFilterProductsByProviderAndSponsorSlug: process.env.VUE_APP_REQUIRES_FILTER_PRODUCTS_BY_PROVIDER_AND_SPONSOR_SLUG || 'true',
  webTitle: process.env.VUE_APP_WEB_TITLE || undefined,
}


export { config }
